import React from 'react';
import { Avatar } from '@material-ui/core';
import { Edit } from '@material-ui/icons';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';

import { personTypes, PM } from 'constants/usersContants';

const useStyles = makeStyles({
  container: {
    textAlign: 'center',
  },
  title: {
    color: '#3D319D',
    marginBottom: '10%',
    textTransform: 'uppercase',
  },
  textInfo: {
    color: '#8E8FA1',
    textAlign: 'left',
  },
  helpUserInfo: {
    color: '#3D319D',
    padding: 0,
    margin: 0,
    textAlign: 'left',
    marginTop: '3%',
  },
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    width: '100%',
    textAlign: 'center',
  },
  subTitle: {
    marginTop: '5%',
    fontSize: '1.1em',
    color: '#8E8FA1',
    textAlign: 'left',
  },
  helpTitle: {
    fontSize: '.9em',
    color: '#8E8FA1',
    textAlign: 'left',
  },

  inputWithHelpIconContainer: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
  },

  // RADIO TYPE COMPANY
  radioContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'row',
    gap: '1rem',
  },
  radioWrapper: {
    flex: 1,
    padding: '2%',
    display: 'flex',
    height: '200px',
    justifyContent: 'space-around',
    alignItems: 'center',
    borderRadius: '15px',
    border: '1px solid #8E8FA1',
    position: 'relative',
  },
  radioWrapperTitle: {
    position: 'absolute',
    fontSize: '1em',
    textTransform: 'uppercase',
    top: -20,
    paddingRight: 10,
    paddingLeft: 10,
    backgroundColor: 'white',
    color: '#8E8FA1',
    zIndex: 10,
  },
  radioLabel: {
    margin: 0,
    padding: '5%',
    height: '100px',
    width: '100px',
    borderRadius: '15px',
    display: 'flex',
    justifyContent: 'center',
    color: '#3D319D',
    fontWeight: 'bold',
    border: '2px solid #3D319D',
    '&:hover': {
      backgroundColor: '#3D319D',
      color: 'white',
    },
  },
  // RADIO WITH ICON

  // OTHER RADIO
  radioTitle: {
    marginTop: '3%',
    fontSize: '1em',
    color: '#8E8FA1',
    textAlign: 'left',
  },
  smallRadioContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-start',
    flexDirection: 'row',
  },
  smallRadioLabel: {
    margin: 0,
    padding: '3% 1%',
    whiteSpace: 'nowrap',
    height: '1em',
    flex: 1,
    display: 'flex',
    justifyContent: 'center',
    color: '#3D319D',
    fontWeight: 'bold',
    borderRight: '2px solid #3D319D',
    borderTop: '2px solid #3D319D',
    borderBottom: '2px solid #3D319D',
    '&:first-child': {
      borderLeft: '2px solid #3D319D',
      borderRadius: '10px 0% 0% 10px',
    },
    '&:last-child': {
      borderRadius: '0px 10px 10px 0px',
    },
    '&:hover': {
      backgroundColor: '#3D319D',
      color: 'white',
    },
  },
  selected: {
    backgroundColor: '#3D319D',
    color: 'white',
  },
  radioError: {
    borderColor: 'red !important',
    color: 'red',
  },
  radio: {
    display: 'none',
  },
  nameTextField: {
    margin: '1%',
  },
  nameTextFieldFull: {
    margin: '1%',
    width: '100%',
  },
  townAndZipCode: {
    display: 'flex',
  },
  town: {
    flex: 1,
  },
  zipCode: {
    flex: 0.5,
  },

  subCategories: {
    paddingLeft: '10%',
    display: 'flex',
    flexDirection: 'column',
  },

  // Input type number
  // inputStyle: {
  //   '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
  //     '-webkit-appearance': 'none',
  //     display: 'none',
  //     backgroundColor: 'red',
  //   },
  // },

  // PARTNER CARD
  partnerCard: {
    position: 'relative',
    cursor: 'pointer',
    textAlign: 'left',
    padding: '10px 20px',
    border: '2px solid #3D319D',
    marginBottom: '2%',
    color: '#3D319D',
    borderRadius: '15px',
    display: 'flex',
    '&:hover': {
      color: 'white',
      backgroundColor: '#3D319D',
      '& $avatar': {
        color: '#3D319D !important',
        backgroundColor: 'white !important',
      },
    },
  },
  partnerCardSelected: {
    color: 'white',
    backgroundColor: '#3D319D',
    '& $avatar': {
      color: '#3D319D !important',
      backgroundColor: 'white !important',
    },
  },
  partnerCardDisable: {
    border: '2px solid lightgray',
    cursor: 'pointer',
    backgroundColor: 'red',
  },
  editIconContainer: {
    position: 'absolute',
    right: '2%',
    top: 0,
    display: 'flex',
    alignItems: 'center',
    height: '100%',
  },
  editIcon: {
    fontSize: '2em',
  },
  avatar: {
    fontSize: '1.1em',
    fontWeight: 'bold',
    color: 'white',
    backgroundColor: '#3D319D',
    marginRight: '3%',
  },
  addPartnerCard: {
    textAlign: 'left',
    padding: '10px 20px',
    border: '2px solid white',
    marginTop: '8%',
    marginBottom: '5%',
    color: '#3D319D',
    fontWeight: 'bold',
    fontSize: '1.2em',
    borderRadius: '15px',
    alignItems: 'center',
    display: 'flex',
    cursor: 'pointer',
    '&:hover': {
      color: 'white',
      backgroundColor: '#3D319D',
      '& $avatar': {
        color: '#3D319D !important',
        backgroundColor: 'white !important',
      },
    },
  },
  parnterName: {
    fontWeight: 'bold',
    fontSize: '1.2em',
  },
});

const PartnerCard = ({ partner, handleClick, canEdit, isSelected }) => {
  const classes = useStyles();

  const getName = () => {
    if (partner.personne_physique_morale === PM) {
      return partner.raison_sociale_actionnaire_personne_morale_sasu;
    }
    return `${partner.partner_name} ${partner.partner_firstname}`;
  };

  return (
    <div
      className={`${classes.partnerCard} ${
        isSelected ? classes.partnerCardSelected : ''
      }`}
      onClick={() => {
        handleClick(partner.id);
      }}
    >
      <Avatar className={classes.avatar}>
        {`${
          partner.partner_name
            ? partner.partner_name.toUpperCase().charAt(0)
            : ''
        }${
          partner.partner_firstname
            ? partner.partner_firstname.toUpperCase().charAt(0)
            : ''
        }`}
      </Avatar>
      <div>
        <div className={classes.parnterName}>{getName()}</div>
        {
          personTypes.find(
            (personType) =>
              personType.value === partner.personne_physique_morale
          ).label
        }
      </div>
      {canEdit && (
        <div className={classes.editIconContainer}>
          <Edit className={classes.editIcon} />
        </div>
      )}
    </div>
  );
};

PartnerCard.propTypes = {
  partner: PropTypes.object,
  handleClick: PropTypes.func,
  canEdit: PropTypes.bool,
  isSelected: PropTypes.bool,
};

export default PartnerCard;
